export const SALE = 'SALE';
// 상품 상태값(status.code) - 판매대기
export const WAIT = 'WAIT';
// 승인 상태값(approvalStatusList[].status.code) - 승인 대기중
export const WAITING = 'WAITING';
export const MAINTENANCE_SALE = 'MAINTENANCE_SALE';
export const COMPLETED = 'COMPLETED';
export const ORIGIN_DATA_REGISTER = 'ORIGIN_DATA_REGISTER';
export const BEFORE_SALE = 'BEFORE_SALE';
export const PAUSE = 'PAUSE';
export const BEFORE_CONSULTING = 'BEFORE_CONSULTING';
export const AFTER_CONSULTING = 'AFTER_CONSULTING';
export const DELETED = 'DELETED';
